import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Fallback if clsx or twMerge are not available
export function cnFallback(...inputs: (string | undefined | null | boolean)[]) {
  return inputs.filter(Boolean).join(' ')
}

// Format grade level for display purposes
export function formatGradeLevelForDisplay(gradeLevel: string): string {
  if (!gradeLevel) return 'N/A';
  
  const trimmed = gradeLevel.trim();
  
  // Handle Primary grades
  if (trimmed.toLowerCase().includes('primary')) {
    const match = trimmed.match(/(\d+)/);
    if (match) {
      return `Primary ${match[1]}`;
    }
    return trimmed;
  }
  
  // Handle Nursery grades
  if (trimmed.toLowerCase().includes('nursery')) {
    const match = trimmed.match(/(\d+)/);
    if (match) {
      return `Nursery ${match[1]}`;
    }
    return trimmed;
  }
  
  // Handle Pre-Nursery
  if (trimmed.toLowerCase().includes('pre')) {
    return 'Pre-Nursery';
  }
  
  // Handle JSS grades
  if (trimmed.toLowerCase().includes('jss') || trimmed.toLowerCase().includes('junior')) {
    const match = trimmed.match(/(\d+)/);
    if (match) {
      return `JSS ${match[1]}`;
    }
    return trimmed;
  }
  
  // Handle SSS grades
  if (trimmed.toLowerCase().includes('sss') || trimmed.toLowerCase().includes('senior')) {
    const match = trimmed.match(/(\d+)/);
    if (match) {
      return `SSS ${match[1]}`;
    }
    return trimmed;
  }
  
  // Handle Year format
  if (trimmed.toLowerCase().includes('year')) {
    const match = trimmed.match(/(\d+)/);
    if (match) {
      return `Year ${match[1]}`;
    }
    return trimmed;
  }
  
  // Return as-is if no pattern matches
  return trimmed;
}